export interface ResearchParams {
  projectId: string
}

const endpoints = {
  productLineup: ({ projectId }: ResearchParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/research/insights/product_lineup/`
  },
  contentDistributionChannels: ({ projectId }: ResearchParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/research/insights/content_distribution_channels/`
  },
  competitorArchetypes: ({ projectId }: ResearchParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/research/insights/competitor_archetypes/`
  },
  competitorBenefits: ({ projectId }: ResearchParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/research/insights/competitor_benefits/`
  },
  competitorCreatives: ({ projectId }: ResearchParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/research/insights/competitor_creatives/`
  },
  competitorsStatistics: ({ projectId }: ResearchParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/research/competitors/statistics/`
  },
  competitorMeanings: ({ projectId }: ResearchParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/research/insights/competitor_meanings/`
  },
  competitorMotives: ({ projectId }: ResearchParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/research/insights/competitor_motives/`
  },
  competitorPains: ({ projectId }: ResearchParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/research/insights/competitor_pains/`
  },
  competitorPositioningAnalysis: ({ projectId }: ResearchParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/research/insights/competitor_positioning_analysis/`
  },
  competitorValueProposition: ({ projectId }: ResearchParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/research/insights/competitor_value_proposition/`
  },
  competitorPromocodes: ({ projectId }: ResearchParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/research/insights/competitor_promocodes/`
  },
  competitorPromotions: ({ projectId }: ResearchParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/research/insights/competitor_promotions/`
  },
  contentFormats: ({ projectId }: ResearchParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/research/insights/content_formats/`
  },
  loyaltyPrograms: ({ projectId }: ResearchParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/research/insights/loyalty_programs/`
  },
  marketInnovations: ({ projectId }: ResearchParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/research/insights/market_innovations/`
  },
  missionVisionValues: ({ projectId }: ResearchParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/research/insights/mission_vision_values/`
  },
}

export default endpoints
